<div class="donate-buttons-dialog">
  <div class="donate-buttons-dialog__header">
    <div class="donate-buttons-dialog__header-left">
      <div class="donate-buttons-dialog__icon-badge" aria-hidden="true"></div>
      <h2 class="donate-buttons-dialog__title">
        {{ 'fund.donate_buttons_dialog.title' | translateLang }}
      </h2>
    </div>
    <button
      class="donate-buttons-dialog__close-btn"
      (click)="onClose()"
      type="button"
      aria-label="Close"
    >
      <svg width="8" height="8" viewBox="0 0 7 7" fill="none">
        <path
          d="M6.5 0.5L0.5 6.5M0.5 0.5L6.5 6.5"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>

  <div class="donate-buttons-dialog__content">
    <p class="donate-buttons-dialog__content-intro">
      {{ 'fund.donate_buttons_dialog.content_intro' | translateLang }}
    </p>
    <p class="donate-buttons-dialog__content-title">
      {{ 'fund.donate_buttons_dialog.content_title' | translateLang }}
    </p>
    <p class="donate-buttons-dialog__content-description">
      {{ 'fund.donate_buttons_dialog.content_description' | translateLang }}
    </p>

    <div class="donate-buttons-dialog__html-card">
      <div class="donate-buttons-dialog__html-card-header">
        <img
          class="donate-buttons-dialog__html-card-icon"
          src="/assets/images/icons/donate-buttons-code-icon.svg"
          alt=""
        />
        <p class="donate-buttons-dialog__html-card-title">
          {{ 'fund.donate_buttons_dialog.html_code_title' | translateLang }}
        </p>
      </div>

      <div class="donate-buttons-dialog__html-card-body">
        <p class="donate-buttons-dialog__html-instruction">
          {{ 'fund.donate_buttons_dialog.html_code_instruction' | translateLang }}
        </p>

        <div
          class="donate-buttons-dialog__design-options"
          role="radiogroup"
          [attr.aria-label]="'fund.donate_buttons_dialog.design_options_label' | translateLang"
        >
          <div class="donate-buttons-dialog__design-option">
            <input
              type="radio"
              name="donate-button-design"
              class="donate-buttons-dialog__design-checkbox"
              [checked]="selectedDesign() === 'light'"
              (change)="selectDesign('light')"
              [attr.aria-label]="'fund.donate_buttons_dialog.design_light_label' | translateLang"
            />
            <button
              type="button"
              class="donate-buttons-dialog__design-preview donate-buttons-dialog__design-preview--light"
              (click)="selectDesign('light'); onPreviewClick()"
              [attr.aria-label]="'fund.donate_buttons_dialog.preview_aria' | translateLang"
            >
              <img
                class="donate-buttons-dialog__design-preview-icon"
                src="/assets/images/icons/donate-buttons-preview-light-icon.svg"
                alt=""
              />
              <span class="donate-buttons-dialog__design-preview-text">
                <span class="donate-buttons-dialog__design-preview-org">TrustBridge</span>
                <span class="donate-buttons-dialog__design-preview-cta">DONATE NOW</span>
              </span>
            </button>
          </div>

          <div class="donate-buttons-dialog__design-option">
            <input
              type="radio"
              name="donate-button-design"
              class="donate-buttons-dialog__design-checkbox"
              [checked]="selectedDesign() === 'dark'"
              (change)="selectDesign('dark')"
              [attr.aria-label]="'fund.donate_buttons_dialog.design_dark_label' | translateLang"
            />
            <button
              type="button"
              class="donate-buttons-dialog__design-preview donate-buttons-dialog__design-preview--dark"
              (click)="selectDesign('dark'); onPreviewClick()"
              [attr.aria-label]="'fund.donate_buttons_dialog.preview_aria' | translateLang"
            >
              <img
                class="donate-buttons-dialog__design-preview-icon"
                src="/assets/images/icons/donate-buttons-preview-dark-icon.svg"
                alt=""
              />
              <span class="donate-buttons-dialog__design-preview-text">
                <span class="donate-buttons-dialog__design-preview-org">TrustBridge</span>
                <span class="donate-buttons-dialog__design-preview-cta">DONATE NOW</span>
              </span>
            </button>
          </div>
        </div>

        <div class="donate-buttons-dialog__code-block">
          <code class="donate-buttons-dialog__code-text">{{ embedCode() }}</code>
          <button
            type="button"
            class="donate-buttons-dialog__copy-button"
            (click)="copyEmbedCode()"
          >
            <img
              class="donate-buttons-dialog__copy-icon"
              src="/assets/images/icons/donate-buttons-copy-icon.svg"
              alt=""
            />
            <span>{{
              (codeCopied()
                ? 'fund.donate_buttons_dialog.copied'
                : 'fund.donate_buttons_dialog.copy'
              ) | translateLang
            }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="donate-buttons-dialog__html-card">
      <div class="donate-buttons-dialog__html-card-header">
        <img
          class="donate-buttons-dialog__html-card-icon"
          src="/assets/images/icons/donate-buttons-code-icon.svg"
          alt=""
        />
        <p class="donate-buttons-dialog__html-card-title">
          {{ 'fund.donate_buttons_dialog.give_url_title' | translateLang }}
        </p>
      </div>

      <div class="donate-buttons-dialog__html-card-body">
        <p class="donate-buttons-dialog__html-instruction">
          {{ 'fund.donate_buttons_dialog.give_url_instruction' | translateLang }}
        </p>

        <div class="donate-buttons-dialog__code-block">
          <code class="donate-buttons-dialog__code-text donate-buttons-dialog__code-text--url">{{
            giveUrl()
          }}</code>
          <button type="button" class="donate-buttons-dialog__copy-button" (click)="copyGiveUrl()">
            <img
              class="donate-buttons-dialog__copy-icon"
              src="/assets/images/icons/donate-buttons-copy-icon.svg"
              alt=""
            />
            <span>{{
              (urlCopied()
                ? 'fund.donate_buttons_dialog.copied'
                : 'fund.donate_buttons_dialog.copy'
              ) | translateLang
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
